import { EmailAddress } from 'common/store/genesys-cloud/conversations/emails/models/email-address.model';

export const getFormattedAddress = (emailAddress: EmailAddress): string => {
  if (emailAddress.name) {
    return `"${ emailAddress.name }" <${ emailAddress.email }>`;
  }

  return `${ emailAddress.email }`;
};

export const getFormattedAddresses = (emailAddresses: EmailAddress[]): string => {
  return emailAddresses.map(e => getFormattedAddress(e)).join('; ').trim();
};
